import { Box, Stack } from "@chakra-ui/react";
import { useTutorApplicationFlow } from "../../components/VerificationWrapper";
import { observer } from "mobx-react-lite";
import React from "react";
import { IRootStore } from "../../stores";
import { STEPS } from "../../stores/utils";
import {
  VerifyEducationSection,
  VerifyWorkHistorySection,
} from "../../tutor-application/pages/VerificationPage";

type Props = {
  store: IRootStore;
};

function VerificationPage({ store }: Props) {
  const { getFormWrapperProps } = useTutorApplicationFlow(store);
  return (
    <Box
      as="section"
      className="forms-section"
      maxW={["100%", "100%", "640px"]}
      px={[5, 8, 0]}
      py={[10, 12]}
      mx="auto"
    >
      <Stack justifyContent="stretch" alignItems="stretch" spacing={[6, 8]}>
        <VerifyEducationSection
          {...getFormWrapperProps(STEPS.UPLOAD_EDUCATION)}
        />
        <VerifyWorkHistorySection {...getFormWrapperProps(STEPS.UPLOAD_WORK)} />
      </Stack>
    </Box>
  );
}

export default observer(VerificationPage);
